<style scoped>
  .section-background-bottom-border-jagged {
    position: absolute;
    right: 0;
    bottom: 16px;
    left: 0;
    z-index: 1
  }
  .jagged-border.bottom {
    background: conic-gradient(from -45deg at bottom,transparent,#fff 1deg 89deg,transparent 90deg) 50%/14px 100%;
    bottom: -6px;
    top: initial;
  }
  .jagged-border-two.bottom {
    background: conic-gradient(from -45deg at bottom,transparent,#d4d4d4 1deg 89deg,transparent 90deg) 50%/14px 100%;
    bottom: -8px;
    top: initial;
  }
</style>

<template>
  <div class="section-background-bottom-border-jagged">
    <div class="jagged-border-two bottom"></div>
    <div class="jagged-border bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'TemplateSectionJaggedBorderBottom',
};
</script>
